import { createContext, useCallback, useContext, useState } from 'react';
import { BaseTicketResponse } from '../models';

interface ModalContextValue {
  flowType: ModalTypes | undefined;
  ticketData?: BaseTicketResponse | null;
  setTicketData: (data: BaseTicketResponse | null) => void;
  openCallModal: () => void;
  openAttendModal: () => void;
  closeModal: () => void;
}

export const TicketFlowContext = createContext<ModalContextValue | undefined>(
  undefined
);

export enum ModalTypes {
  CALL_NEXT = 'CALL_NEXT',
  ATTEND = 'ATTEND',
}

interface TicketFlowProviderProps {
  children: React.ReactNode;
}

export const TicketFlowProvider = ({ children }: TicketFlowProviderProps) => {
  const [flowType, setFlowType] = useState<ModalTypes>();
  const [ticketData, setTicketData] = useState<BaseTicketResponse | null>();

  const openCallModal = useCallback(() => {
    setFlowType(ModalTypes.CALL_NEXT);
  }, []);

  const openAttendModal = useCallback(() => {
    setFlowType(ModalTypes.ATTEND);
  }, []);

  const closeModal = useCallback(() => {
    setFlowType(undefined);
  }, []);

  return (
    <TicketFlowContext.Provider
      value={{
        flowType,
        ticketData,
        setTicketData,
        openCallModal,
        openAttendModal,
        closeModal,
      }}
    >
      {children}
    </TicketFlowContext.Provider>
  );
};

export const useTicketFlowModals = () => {
  const context = useContext(TicketFlowContext);
  if (!context) {
    throw new Error('useModalData must be used within a ModalDataProvider');
  }
  return context;
};
